<template>
  <div class="News">
    <div class="news-page-top">
      <h2 class="color-white">{{ $t("nav__news") }}</h2>
      <!-- <customSelect placeholder="Eng so'ngi" /> -->
    </div>
    <div class="news-swiperpage">
      <div class="video-section">
        <div v-for="(item, index) in Swiperdatas" :key="index" @click="openModal(item.videoUrl)">
          <div class="swiper-card">
            <div class="imgbox">
              <img
                v-if="item.PosterImageUrl && !item.posterError"
                :src="item.PosterImageUrl"
                alt=""
                @error="item.posterError = true"
              />
              <video
                v-else-if="item.videoUrl"
                :src="item.videoUrl + '#t=0.5'"
                preload="metadata"
                muted
                style="width: 100%; height: 100%; object-fit: cover;"
              ></video>
              <p>{{ item.direction }}</p>
            </div>
            <div class="contentbox">
              <h2>{{ item.title }}</h2>

              <div class="bottom">
                <p>{{ timeAgo(item?.createdAt) }}</p>
                <div class="right">
                  <!-- <p class="sendkey" @click="copyLink"><Icons name="SendKey" /></p> -->
                  <!-- <p class="like" @click="handleLike(item.id)">
                    <Icons :name="item.liked ? 'liked' : 'loves'" />{{ item.likes }}
                  </p> -->
                  <p class="show pointer" @click="openModal(item.videoUrl)">
                    <Icons name="show" /> Ko'rish
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="videoModel" @click="Overlay($event)" v-if="vidoeModalHandler">
  <div class="video-container" @click.stop>
    <video width="100%" controls class="video" height="100%" :src="oneVideo"></video>
  </div>
</div>
  <Toastiff :toastOptions="toastOptions" />
</template>
<script>
import customSelect from "@/components/Template/customSelect.vue";
import Icons from "@/components/Template/Icons.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Autoplay } from "swiper/modules";
import Toastiff from "../../Utils/Toastiff.vue";

export default {
  components: {
    Swiper,
    SwiperSlide,
    customSelect,
    Icons,
    Toastiff,
  },
  setup() {
    return { Swiper, SwiperSlide, Navigation, Autoplay };
  },
  data() {
    return {
      oneVideo:null,
      Swiperdatas: [],
      vidoeModalHandler: false,
      toastOptions: {
        open: false,
        text: "Default Toast Message",
        style: {
          background: "#E0F9F2",
        },
      },
    };
  },
  methods: {
    Overlay(param) {
      console.log(param.target.classList);
      if (param.target.classList[0] !== "video-container" && param.target.classList[0] !== "video") {
        this.vidoeModalHandler = false;
      }
    },
    openModal(video) {
      this.vidoeModalHandler = true;
      this.oneVideo= null
      this.oneVideo=video
    },
    timeAgo(date) {
      const now = new Date();
      const past = new Date(date);
      const diffMs = now - past;

      const seconds = Math.floor(diffMs / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const weeks = Math.floor(days / 7);
      const months = Math.floor(days / 30);

      if (months > 0) return `${months} oy oldin`;
      if (weeks > 0) return `${weeks} hafta oldin`;
      if (days > 0) return `${days} kun oldin`;
      if (hours > 0) return `${hours} soat oldin`;
      if (minutes > 0) return `${minutes} daqiqa oldin`;
      return "hozir";
    },
    copyLink() {
      const link = window.location.href;
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.toastOptions = {
            open: true,
            text: "Nusxalandi",
            style: {
              background: "#E0F9F2",
              color: "#00D097",
            },
          };
        })
        .catch((err) => {
          console.error("Copy xatosi:", err);
        });
    },
    handleLike(id) {
      const item = this.Swiperdatas.find((item) => item.id === id);
      if (item) {
        item.liked = !item.liked;
        item.likes += item.liked ? 1 : -1;
      }
    },
    getNews() {
      // Fetch news data from API or other source
      //fetch("https://algoritm.techinfo.uz/api/videos/video-opinions")
      fetch("https://algowebback-production.up.railway.app/video_opinion")
        .then((response) => response.json())
        .then((data) => {
          const list = Array.isArray(data) ? data : (data.data || []);
          const backendHost = "https://algowebback-production.up.railway.app";
          this.Swiperdatas = list.map((item) => {
            let video = item.videoUrl || item.video || "";
            if (video && !video.startsWith("http")) {
              video = `${backendHost}/${video.replace(/^\//, "")}`;
            }

            let poster = item.PosterImageUrl || item.poster || "";
            if (poster && !poster.startsWith("http")) {
              poster = `${backendHost}/${poster.replace(/^\//, "")}`;
            }

            return {
              ...item,
              videoUrl: video,
              PosterImageUrl: poster,
              direction: item.direction || item.subtitle || "Tadbirlar",
            };
          });
          console.log("Fetched news data:", this.Swiperdatas);
        })
        .catch((error) => {
          console.error("Error fetching news data:", error);
        });
    },
  },
  
  mounted() {
    console.log("News page mounted");
    this.getNews();
  },
};
</script>

<style>
.videoModel {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.538);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-container {
  width: 40%;
  height: 90%;
  padding: 40px;
  background: #1f1c1c;
  border-radius: 12px;
}
.video{
  object-fit: cover;
}

.News {
  width: 100%;
  background-color: #000000;
  margin-top: 69px;
  padding-bottom: 40px;
  color: #fff;
}
.news-page-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.color-white {
  color: #fff;
  font-size: 69px;
  position: relative;
}
.color-white::after {
  content: "*";
  margin-left: 10px;
  color: #f8da0b;
  position: absolute;
}
.news-swiperpage {
  width: 100%;
  height: 100%;
}
.mySwiper {
  width: 100%;
  height: 100%;
  margin-top: 30px;
}
.newSwip {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 60px;
}
.news-swiperpage {
  width: 100%;
  border-radius: 10px;
  padding: 8px;
  display: flex;
}
.video-section {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
}
.video-section > div {
  min-width: 250px;
  max-width: 31%;
  background: #0d0d0d;
  padding: 16px;
  border-radius: 12px;
  flex-shrink : 2;
}
.imgbox {
  position: relative;
}
.imgbox > img {
  object-fit: cover;
}
.show {
  cursor: pointer;
}
.imgbox p {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: #000;
  padding: 10px 40px;
  border-radius: 50px;
  font-size: 16px;
}
.swiper-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.contentbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}
.contentbox p {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.4);
}
.swiper-card .imgbox img {
  width: 100%;
  height: 320px;
  border-radius: 10px;
  border-radius: 10px;
}
.contentbox > .bottom {
  display: flex;
  justify-content: space-between;
}
.swiper-button-prev {
  box-sizing: content-box;
  position: absolute;
  z-index: 2;
  top: 97%;
  left: 94.5%;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: 5px;
  background-color: #1f1c1c;

  color: #fff;
}

.contentbox > .bottom > .right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.contentbox > .bottom > .right > p {
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 5px;
  background: rgba(255, 255, 255, 0.05);
  padding: 8px 12px;
  border-radius: 10px;
}
.contentbox > .right > .sendkey {
  background: rgba(255, 255, 255, 0.05);
  padding: 8px 12px;
  border-radius: 10px;
  color: aqua;
}
@media (max-width: 1124px) {
  .video-section {
    justify-content: center;
  }
  .video-section > div {
    max-width: 45%;

  }
}
@media (max-width: 768px) {
  .news-page-top {
    align-items: start;
    flex-direction: column;
    gap: 20px;
  }
  .color-white {
    font-size: 40px;
  }
  .video-section{
    width: 100%;
    height: 100%;
  }
  .video-section > div {
    max-width: 90%;
  }
  .video-container {
    width: 90%;
    height: 80%;
    padding: 20px;
  }
}
@media (max-width: 500px) {
  .contentbox > h2 {
    font-size: 18px;
  }
  .contentbox > .bottom {
    flex-direction: column-reverse;
    align-items: center;
    gap: 10px;
  }
  .swiper-card {
    padding: 12px;
  }
}
</style>
